import { countryCodes } from "~~/i18n";
import { FULL_MONTH_IN_SECONDS } from "~~/constants/numbers";

export const COHORT_TIER_KEY = {
  NOT_LOGGED_IN: 'not-logged-in',
  TIER_0: 'monetary-cohort-tier-0',
  BASE_TIER: 'monetary-cohort-base-tier',
  TIER_1: 'monetary-cohort-tier-1',
  TIER_2: 'monetary-cohort-tier-2',
  TIER_3: 'monetary-cohort-tier-3',
  TIER_4: 'monetary-cohort-tier-4',
} as const;


export const NEWSLETTER_VOUCHER_CODE = {
  [countryCodes.AT]: {
    voucherDescription: 'CRM_WELCOME',
    voucherValue: 15,
    minimumPurchaseValue: 175,
    voucherExpireTime: FULL_MONTH_IN_SECONDS,
    status: 'submitted',
  },
  [countryCodes.BE]: {
    voucherDescription: 'CRM_WELCOME',
    voucherValue: 15,
    minimumPurchaseValue: 175,
    voucherExpireTime: FULL_MONTH_IN_SECONDS,
    status: 'submitted',
  },
  [countryCodes.BG]: {
    voucherDescription: '',
    voucherValue: 0,
    minimumPurchaseValue: 0,
    voucherExpireTime: 0,
    status: '',
  },
  [countryCodes.CH]: {
    voucherDescription: 'CRM_WELCOME',
    voucherValue: 18,
    minimumPurchaseValue: 210,
    voucherExpireTime: FULL_MONTH_IN_SECONDS,
    status: 'submitted',
  },
  [countryCodes.CZ]: {
    voucherDescription: 'CRM_WELCOME',
    voucherValue: 400,
    minimumPurchaseValue: 4600,
    voucherExpireTime: FULL_MONTH_IN_SECONDS,
    status: 'submitted',
  },
  [countryCodes.DE]: {
    voucherDescription: 'CRM_WELCOME',
    voucherValue: 15,
    minimumPurchaseValue: 175,
    voucherExpireTime: FULL_MONTH_IN_SECONDS,
    status: 'submitted',
  },
  [countryCodes.DK]: {
    voucherDescription: 'CRM_WELCOME',
    voucherValue: 120,
    minimumPurchaseValue: 1320,
    voucherExpireTime: FULL_MONTH_IN_SECONDS,
    status: 'submitted',
  },
  [countryCodes.ES]: {
    voucherDescription: 'CRM_WELCOME',
    voucherValue: 15,
    minimumPurchaseValue: 175,
    voucherExpireTime: FULL_MONTH_IN_SECONDS,
    status: 'submitted',
  },
  [countryCodes.FI]: {
    voucherDescription: 'CRM_WELCOME',
    voucherValue: 15,
    minimumPurchaseValue: 175,
    voucherExpireTime: FULL_MONTH_IN_SECONDS,
    status: 'submitted',
  },
  [countryCodes.FR]: {
    voucherDescription: 'CRM_WELCOME',
    voucherValue: 15,
    minimumPurchaseValue: 175,
    voucherExpireTime: FULL_MONTH_IN_SECONDS,
    status: 'submitted',
  },
  [countryCodes.GB]: {
    voucherDescription: 'CRM_WELCOME',
    voucherValue: 15,
    minimumPurchaseValue: 160,
    voucherExpireTime: FULL_MONTH_IN_SECONDS,
    status: 'submitted',
  },
  [countryCodes.GR]: {
    voucherDescription: '',
    voucherValue: 0,
    minimumPurchaseValue: 0,
    voucherExpireTime: 0,
    status: '',
  },
  [countryCodes.HR]: {
    voucherDescription: '',
    voucherValue: 0,
    minimumPurchaseValue: 0,
    voucherExpireTime: 0,
    status: '',
  },
  [countryCodes.HU]: {
    voucherDescription: 'CRM_WELCOME',
    voucherValue: 5000,
    minimumPurchaseValue: 58000,
    voucherExpireTime: FULL_MONTH_IN_SECONDS,
    status: 'submitted',
  },
  [countryCodes.IE]: {
    voucherDescription: 'CRM_WELCOME',
    voucherValue: 15,
    minimumPurchaseValue: 175,
    voucherExpireTime: FULL_MONTH_IN_SECONDS,
    status: 'submitted',
  },
  [countryCodes.IT]: {
    voucherDescription: 'CRM_WELCOME',
    voucherValue: 15,
    minimumPurchaseValue: 175,
    voucherExpireTime: FULL_MONTH_IN_SECONDS,
    status: 'submitted',
  },
  [countryCodes.LT]: {
    voucherDescription: '',
    voucherValue: 0,
    minimumPurchaseValue: 0,
    voucherExpireTime: 0,
    status: '',
  },
  [countryCodes.NL]: {
    voucherDescription: 'CRM_WELCOME',
    voucherValue: 15,
    minimumPurchaseValue: 175,
    voucherExpireTime: FULL_MONTH_IN_SECONDS,
    status: 'submitted',
  },
  [countryCodes.NO]: {
    voucherDescription: 'CRM_WELCOME',
    voucherValue: 150,
    minimumPurchaseValue: 1750,
    voucherExpireTime: FULL_MONTH_IN_SECONDS,
    status: 'submitted',
  },
  [countryCodes.PL]: {
    voucherDescription: 'CRM_WELCOME',
    voucherValue: 70,
    minimumPurchaseValue: 780,
    voucherExpireTime: FULL_MONTH_IN_SECONDS,
    status: 'submitted',
  },
  [countryCodes.PT]: {
    voucherDescription: 'CRM_WELCOME',
    voucherValue: 15,
    minimumPurchaseValue: 175,
    voucherExpireTime: FULL_MONTH_IN_SECONDS,
    status: 'submitted',
  },
  [countryCodes.RO]: {
    voucherDescription: 'CRM_WELCOME',
    voucherValue: 75,
    minimumPurchaseValue: 870,
    voucherExpireTime: FULL_MONTH_IN_SECONDS,
    status: 'submitted',
  },
  [countryCodes.SE]: {
    voucherDescription: 'CRM_WELCOME',
    voucherValue: 170,
    minimumPurchaseValue: 1900,
    voucherExpireTime: FULL_MONTH_IN_SECONDS,
    status: 'submitted',
  },
  [countryCodes.SI]: {
    voucherDescription: '',
    voucherValue: 0,
    minimumPurchaseValue: 0,
    voucherExpireTime: 0,
    status: '',
  },
  [countryCodes.SK]: {
    voucherDescription: 'CRM_WELCOME',
    voucherValue: 15,
    minimumPurchaseValue: 175,
    voucherExpireTime: FULL_MONTH_IN_SECONDS,
    status: 'submitted',
  },
};